module.exports = __webpack_public_path__ + "static/img/bg.e2d72afe.png";